/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This chat doesn't exist or you don't have access to it. The link may be broken or the chat may have been removed." |
*
* @param {Chat_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_not_found_description = /** @type {((inputs?: Chat_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Chat existiert nicht oder du hast keinen Zugriff darauf. Der Link ist möglicherweise ungültig oder der Chat wurde entfernt.")
	return /** @type {LocalizedString} */ ("This chat doesn't exist or you don't have access to it. The link may be broken or the chat may have been removed.")
});